/**
 * Utility functions for audit-related API operations
 */
/**
 * Create or update an audit
 * @param {Object} context - Vue component instance (this)
 * @param {Object} audit - The audit data
 * @param {boolean} newEntry - Whether this is a new entry
 * @returns {Promise} - API response promise
 */
export function saveAudit(context, audit, newEntry) {
    const endpoint = newEntry ? 'audit/create' : 'audit/update';
    return context.$postData(endpoint, audit);
}

/**
 * Signal that a scheduled audit has been opened for perform (SCHEDULED → DRAFT).
 * @param {Object} context - Vue component instance (this)
 * @param {number} auditId - The audit id
 * @returns {Promise} - API response promise
 */
export function markAuditPerformStarted(context, auditId) {
    return context.$postData('audit/update', {
        id: auditId,
        perform_started: true,
    });
}

/**
 * Persist an in-progress audit draft (partial form_json, no completed_at).
 * @param {Object} context - Vue component instance (this)
 * @param {Object} audit - The audit payload (must include id for updates)
 * @returns {Promise} - API response promise
 */
export function saveAuditDraft(context, audit) {
    const endpoint = audit?.id ? 'audit/update' : 'audit/create';
    return context.$postData(endpoint, audit);
}

/**
 * Persist a completed audit (caller sets completed_at).
 * @param {Object} context - Vue component instance (this)
 * @param {Object} audit - The audit payload
 * @returns {Promise} - API response promise
 */
export function completeAudit(context, audit) {
    const endpoint = audit?.id ? 'audit/update' : 'audit/create';
    return context.$postData(endpoint, audit);
}

/**
 * Delete an audit
 * @param {Object} context - Vue component instance (this)
 * @param {Object} audit - The audit to delete
 * @returns {Promise} - API response promise
 */
export function deleteAudit(context, audit) {
    return context.$postData('audit/delete', { id: audit.id });
}
